import React from "react";
import "./styles.scss";

const Zone = ({ className, shots = {} }) => {
  const { z1 = 0, z2 = 0, z3 = 0, z4 = 0, z5 = 0 } = shots;
  const upperLimit = 2;
  const getOpacityClass = (count) => {
    if (count <= upperLimit) return "opacity-0";
    const level = Math.min(10, Math.ceil(count));
    return `opacity-${level}`;
  };

  return (
    <div className={`bild-hotzone-container ${className}`}>
      <div
        className={`hotzone-block hotzone-end-block ${getOpacityClass(z1)} ${
          z1 > upperLimit ? "shots-zone" : ""
        }`}
      >
        {z1 > upperLimit && <span>{z1}</span>}
      </div>
      <div className="hotzone-block hotzone-inner-block">
        <div
          className={`hotzone-mid-block ${getOpacityClass(z2)} ${
            z2 > upperLimit ? "shots-zone" : ""
          }`}
        >
          {z2 > upperLimit && <span>{z2}</span>}
        </div>

        <div
          className={`hotzone-mid-block ${getOpacityClass(z3)} ${
            z3 > upperLimit ? "shots-zone" : ""
          }`}
        >
          {z3 > upperLimit && <span>{z3}</span>}
        </div>

        <div
          className={`hotzone-mid-block ${getOpacityClass(z4)} ${
            z4 > upperLimit ? "shots-zone" : ""
          }`}
        >
          {z4 > upperLimit && <span>{z4}</span>}
        </div>
      </div>

      <div
        className={`hotzone-block hotzone-end-block ${getOpacityClass(z5)} ${
          z5 > upperLimit ? "shots-zone" : ""
        }`}
      >
        {z5 > upperLimit && <span>{z5}</span>}
      </div>
    </div>
  );
};

export default Zone;
